import DateHelper from '../../../helpers/DateHelper';
import moment from "moment";

export default function dateFilter(typeDate) {

    return function deltaIndicator(params) {

        const div = document.createElement('div');

        div.innerHTML = `
        <div class="vs-component vs-con-input-label vs-input vs-input-primary">
            <div class="vs-con-input">
                <input type="text" class="vs-inputx vs-input--input normal hasValue hasIcon icon-after-input" style="border: 1px solid rgba(0, 0, 0, 0.2);" />
                <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-search null icon-after"></i>
            </div>
        </div>`;

        const $componentInput = div.querySelector('.vs-input');
        const $containerInput = $componentInput.querySelector('.vs-con-input');
        const $input = $containerInput.querySelector('input');

        if (params.value != null && params.value !== undefined && params.value.trim() !== "") {
            const momentDate = moment(params.value, "YYYY-MM-DD");

            if (momentDate.isValid()) {
                $input.value = momentDate.format("DD/MM/YYYY");
            } else {
                $input.value = params.value;
            }
        }

        $input.oninput = (event) => {

            if (typeDate === 'month') {
                DateHelper.dateMaskMonthYear(event);
            } else {
                DateHelper.dateMask(event);
            }

            const inputValue = event.target.value;

            if (!inputValue) {
                params.setFilter(params.filterName, '')
            }

            if (inputValue.length === 10 && typeDate !== 'month') {
                const momentDate = moment(inputValue, "DD/MM/YYYY");
                if (momentDate.isValid()) {
                    params.setFilter(params.filterName, momentDate.format("YYYY-MM-DD"));
                } else {
                    params.setFilter(params.filterName, inputValue);
                }

            } else if (inputValue.length === 7 && typeDate === 'month') {
                const momentDate = moment(inputValue, "MM/YYYY");
                if (momentDate.isValid()) {
                    params.setFilter(params.filterName, momentDate.format("YYYY-MM"));
                } else {
                    params.setFilter(params.filterName, inputValue);
                }
            }

        }

        return $componentInput;
    }
}
